import { useContent } from "@/context/ContentContext";
import { resolveImage } from "@/lib/api";
import { ShieldCheck, Award, Globe2, Landmark } from "lucide-react";

const FALLBACK_ICONS = [Landmark, ShieldCheck, Award, Globe2];

export default function CredibilitySection() {
  const { content } = useContent();
  const c = content?.credibility;
  if (!c) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 py-20 border-t border-slate-200">
      <div className="grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-4">
          <div className="text-[10px] font-mono-tmf uppercase tracking-widest text-tmf-blue mb-2">
            {c.eyebrow}
          </div>
          <h2 className="font-display font-black text-4xl md:text-5xl uppercase tracking-tight text-tmf-navy leading-[0.95]">
            {c.title}
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed">{c.subtitle}</p>
        </div>

        <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-3">
          {(c.badges || []).map((b, i) => {
            const Icon = FALLBACK_ICONS[i % FALLBACK_ICONS.length];
            return (
              <div
                key={`${b.name}-${i}`}
                data-testid={`credibility-badge-${i}`}
                className="border border-slate-200 bg-white p-5 flex flex-col items-start brutal-shadow-hover"
              >
                <div className="w-16 h-16 mb-4 flex items-center justify-center bg-blue-50 border border-blue-100">
                  {b.image ? (
                    <img src={resolveImage(b.image)} alt={b.name} className="max-w-full max-h-full object-contain" />
                  ) : (
                    <Icon size={30} strokeWidth={1.75} color="#1E56E0" />
                  )}
                </div>
                <div className="font-display font-black text-lg text-tmf-navy uppercase tracking-tight leading-tight">
                  {b.name}
                </div>
                <div className="text-xs text-slate-500 mt-1 leading-relaxed">{b.note}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
